import {Injectable} from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';

import { Store } from '@ngrx/store';
import * as fromRoot from '../store';
import { AppLocalStorage } from '../helpers';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {

  constructor(private store: Store<fromRoot.State>) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Add the JWT token before sending the request
    const authToken = AppLocalStorage.authToken;
    if (authToken) {
      req = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${authToken}`)
      });
    }

    if (!req.headers.has('Content-Type') && !req.headers.has('RequestWithFiles')) {
      req = req.clone({ headers: req.headers.set('Content-Type', 'application/json') });
    }

    // req = req.clone({ headers: req.headers.set('Accept', 'application/json') });

    return next.handle(req).do(event => { }, err => {
      if (err instanceof HttpErrorResponse) {
        if (err.status === 401 || err.status === 403) {
          console.log('The authentication session expired or the user is not authorized.');
          this.store.dispatch(new fromRoot.LoginRedirect());
        }

        if (err.status === 500) {
          console.log(err)
          this.store.dispatch(new fromRoot.AppActions.Error(err.error.errorId));
        }
      }
    });

  }
}



// WEBPACK FOOTER //
// ./src/app/core/interceptors/authentication.interceptor.ts